import {SKILLS} from "./skills.dataset";
import {JOBS} from "./jobs.dataset";
import {PROFILES} from "./profiles.dataset";
import {PROFILE_SKILLS} from "./profile-skills.dataset";
import {JOBS_CATEGORIES} from "./jobs-categories.dataset";
import {Job, JobCategory, Profile, ProfileSkill, Skill} from "@betrue/shared/interfaces";

export const DATASET: {
  skills: Skill[],
  jobs: Job[],
  profiles: Profile[],
  profileSkills: ProfileSkill[],
  jobCategories: JobCategory[]
}
  = {
  skills: SKILLS,
  jobs: JOBS,
  profiles: PROFILES,
  profileSkills: PROFILE_SKILLS,
  jobCategories: JOBS_CATEGORIES
}
